import { navigationConstants } from "@data/constants/navigationConstants";

// Action to put congrats
export const putCongrats = (data) => ({
    type: navigationConstants.PUT_CONGRATS,
    data
});

// Action to pull next congrats
export const pullNextCongrats = () => ({
    type: navigationConstants.PULL_NEXT_CONGRATS
});

// Action to put next screen params
export const putNextScreenParams = (data) => ({
    type: navigationConstants.PUT_NEXT_SCREEN_PARAMS,
    data
});

// Action to pull next screen params
export const pullNextScreenParams = () => ({
    type: navigationConstants.PULL_NEXT_SCREEN_PARAMS
});